import * as React from 'react';
import DialogBase from '../Shared/DialogBase';
import { CreateUserRequest, UsersRycApiClient } from '../Api/ApiServer';
import { useApi } from '../Api/useApi';
import { Box, Button, Grid2, TextField, Typography } from '@mui/material';
import ClickableCheckbox from '../Shared/ClickableCheckbox';
import { Check } from '@mui/icons-material';

export interface ICreateUserDialogProps {
    open: boolean;
    onClose: (refresh: boolean) => void;
}

export default function CreateUserDialog(props: Readonly<ICreateUserDialogProps>) {
    const { open, onClose } = props;
    const { authorizedApi } = useApi(UsersRycApiClient);
    const [user, setUser] = React.useState<CreateUserRequest>(new CreateUserRequest());
    const [newPassword, setNewPassword] = React.useState<string | null>(null);

    React.useEffect(() => {
        if (open)
            setUser(new CreateUserRequest());
    }, [open]);
    const createUser = React.useCallback(async () => {
        const newUser = await authorizedApi?.createUser(user);
        setNewPassword(newUser?.temporaryPassword ?? null);

    }, [authorizedApi, user]);
    return (
        <DialogBase
            dialogActions={<Box display='flex' width='100%' justifyContent='center'>
                {newPassword === null && <Button variant='contained' disabled={!user.email || user.email === ''} onClick={() => createUser()}>Vytvořit</Button>}
                {newPassword !== null && <Button variant='contained' onClick={() => { setNewPassword(null); onClose(true); }}>Zavřít</Button>}
            </Box>}
            onClose={() => onClose(false)}
            open={open}
            title='Vytvoření uživatele'>
            {newPassword === null && <Grid2 mt={1} spacing={3} container>
                <Grid2 size={{ xs: 12 }}>
                    <TextField
                        error={!user.email || user.email === ''}
                        helperText={!user.email || user.email === '' ? 'Email je povinný' : ''}
                        label='Email'
                        fullWidth
                        value={user.email ?? ''}
                        onChange={(e) => setUser({ ...user, email: e.target.value } as CreateUserRequest)}
                    />
                </Grid2>
                <Grid2 size={{ lg: 6, md: 6, xl: 6, sm: 12 }}>
                    <TextField
                        label='Jméno'
                        fullWidth
                        value={user.firstName ?? ''}
                        onChange={(e) => setUser({ ...user, firstName: e.target.value } as CreateUserRequest)}
                    />
                </Grid2>
                <Grid2 size={{ lg: 6, md: 6, xl: 6, sm: 12 }}>
                    <TextField
                        label='Přijmení'
                        fullWidth
                        value={user.lastName ?? ''}
                        onChange={(e) => setUser({ ...user, lastName: e.target.value } as CreateUserRequest)}
                    />
                </Grid2>
                <Grid2 size={{ xs: 12 }}>
                    <TextField
                        label='Firma'
                        fullWidth
                        value={user.companyName ?? ''}
                        onChange={(e) => setUser({ ...user, companyName: e.target.value } as CreateUserRequest)}
                    />
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                    <ClickableCheckbox checked={user.isAdmin} label='Admin' onChange={(e, ch) => {
                        setUser({ ...user, isAdmin: ch } as CreateUserRequest);
                    }} />
                </Grid2>
                <Grid2 size={{ xs: 6 }}>
                    <ClickableCheckbox checked={user.isAdmin} label='SuperAdmin' onChange={(e, ch) => {
                        setUser({ ...user, isSuperAdmin: ch } as CreateUserRequest);
                    }} />
                </Grid2>


            </Grid2>}
            {newPassword !== null && <Box display='flex' flexDirection='column' alignItems='center'>
                <Check color='success' style={{ height: 50, width: 50 }} />
                <Typography mt={2}>{'Nové heslo:   ' + newPassword}</Typography>

            </Box>}
        </DialogBase>
    );
}
